import { useEffect, useMemo, useRef, useState } from "react";
import Navbar from "../../Navbar/NavbarComponent";
import CustomModal from "../../../shared/components/CustomModal";
import CustomerDetail from "./CustomerDetail";
import {
  ACTION_LABEL,
  BUTTON_LABEL,
  icons,
  LABELS,
  SEARCH_DATA,
  toastError,
  toastSuccess,
} from "../../../shared/constants";
import Table from "../../../shared/components/Table";
import Search from "../../../shared/components/Search";
import { listCheck } from "../../../shared/helperFunc/listCheck";
import { useDeleteModal } from "../../../shared/utils/hooks/useDeleteModal";
import {
  useCustomerGetQuery,
  useCustomerImportMutation,
  useCustomerListQuery,
  useCustomerUpdateMutation,
  useCustomerCreateMutation,
  useCustomerDeleteMutation,
} from "../../../Features/customer/customer-slice";
import { skipToken } from "@reduxjs/toolkit/query";
import AddCustomer from "./AddCustomer";
import { customerValidation } from "../../../shared/validation/customer-validation";
import authProvider from "../../../shared/config/authProvider";
import SimpleButton from "../../../shared/components/Button/Button";
import { CSVLink } from "react-csv";
import {
  dateConvert,
  standardDateConvert,
} from "../../../shared/helperFunc/dateConvert";
import { useFilter } from "../../../shared/utils/hooks/useFilter";
import Filter from "../../Common/Filter/Filter";
import { convertToAppropriateType } from "../../../shared/helperFunc/convertToAppropriateType";
import useDebounce from "../../../shared/utils/hooks/useDebounce";
import { DEBOUNCE_VALUE } from "../../../shared/constants/resource";

const Customer = () => {
  const [sort, setSort] = useState(SEARCH_DATA);
  const [search, setSearch] = useState(false);
  const [count, setCount] = useState();
  // const [multiDelete, setMultiDelete] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [customerId, setCustomerId]: any = useState();
  const [customerDetailData, setCustomerDetailData]: any = useState();
  const iconInput = useRef<any>(null);
  const [recievedMessage, setRecievedMessage] = useState(false);

  const [addCustomerData, setAddCustomerData]: any = useState({
    salutation: undefined,
    firstName: "",
    middleName: "",
    lastName: "",
    address1: undefined,
    address2: undefined,
    city: undefined,
    state: undefined,
    district: undefined,
    pin: undefined,
    // mobileNo: undefined,
    remarks: undefined,
    // gstStateName: undefined,
    // gstin: undefined,
    mobile: "",
    isdCode: "",
    gender: undefined,
    dob: null,
    receiveMessage: "N",
    siteCode: undefined,
    prefCommuniCationMode: undefined,
  });
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [errors, setErrors] = useState({});
  const [handleFilter] = useFilter(sort, setSort);
  const [showFilter, setShowFilter] = useState(false);
  const [filterCalled, setFilterCalled]: any = useState(false);
  const [filterSelectionError, setFilterSelectionError]: any = useState();
  const [filterValues, setFilterValues] = useState<any>({});
  const [defaultFilterValues, setDefaultFilterValues] = useState<any>({});
  const [searchKeyword, setSearchKeyword] = useState(sort.search);
  const debouncedSearchKeyword = useDebounce(searchKeyword, DEBOUNCE_VALUE);

  const [deleteId, deleteShowModal, deleteCloseModal, deleteShowModals] =
    useDeleteModal();

  const queryArgs = useMemo(() => {
    return {
      ...sort,
      search: debouncedSearchKeyword,
    };
  }, [debouncedSearchKeyword, sort]);

  const {
    data,
    isSuccess,
    refetch: customerRefetch,
    isFetching: customerListFetching,
  } = useCustomerListQuery(queryArgs, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const [customerCreate, { isLoading: customerCreateLoading }] =
    useCustomerCreateMutation();

  const [customerUpdate, { isLoading: customerUpdateLoading }] =
    useCustomerUpdateMutation();

  const [customerDelete, { isLoading: customerDeleteLoading }] =
    useCustomerDeleteMutation();

  const {
    data: getCustomerData,
    isLoading: getCustomerLoading,
    isSuccess: getCustomerSuccess,
  } = useCustomerGetQuery(customerId || skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const [customerImport, { isLoading: customerImportLoading }] =
    useCustomerImportMutation();

  useEffect(() => {
    if (customerId && getCustomerSuccess) {
      setCustomerDetailData(getCustomerData.item);
    }
  }, [customerId, getCustomerData, getCustomerSuccess]);

  useEffect(() => {
    if (isSuccess) {
      setCustomerList(data.list);
      setCount(data.count);
    }
  }, [data, isSuccess]);

  const customerAddFlow = async (data: any) => {
    toastSuccess(data.message.messageText || data.message);
    setCustomerId("");
    setEditMode(false);
    setErrors({});
    setShowCustomerModal(false);
    setAddCustomerData({});
    customerRefetch();
  };

  const customerUpdateFlow = async (data: any) => {
    toastSuccess(data.message.messageText || data.message);
    setCustomerId("");
    setEditMode(false);
    setErrors({});
    setShowCustomerModal(false);
    setAddCustomerData({});
    customerRefetch();
  };

  const customerDeleteFlow = async (data: any) => {
    toastSuccess(data.message);
    deleteCloseModal();
    deleteShowModal([]);
    removeMultiDelete();
    setShowCustomerModal(false);
    customerRefetch();
  };

  const customerImportFlow = (data: any) => {
    customerRefetch();
    toastSuccess(data.message);
  };

  const handleApplyFilter = () => {
    // if (Object.keys(sort.filter).length > 0) {
    handleFilter();
    setFilterCalled(!filterCalled);
    setSort({ ...sort, filter: filterValues, filterFlag: true, skip: 0 });
    setShowFilter(!showFilter);
    // } else {
    //   setFilterSelectionError("*Please select atlease one filter.");
    // }
  };

  const handleCallFilter = () => {
    setShowFilter(!showFilter);
  };

  const resetFilter = () => {
    setFilterValues(defaultFilterValues);
    setSort({ ...sort, filter: defaultFilterValues, filterFlag: false });
    setFilterCalled(!filterCalled);
    setFilterSelectionError("");
    setShowFilter(!showFilter);
  };

  const closeFilter = () => {
    setFilterValues(defaultFilterValues);
    setFilterCalled(!filterCalled);
    setFilterSelectionError("");
    setShowFilter(false);
  };

  const handleCustomerModal = () => {
    setShowCustomerModal(true);
  };

  const closeCustomerModal = () => {
    setShowCustomerModal(false);
    setCustomerId("");
    setAddCustomerData({});
    setEditMode(false);
    setErrors({});
  };

  const handleOnChange = (e: any) => {
    // setAddCustomerData({ ...addCustomerData, [e.target.name]: e.target.value });
    setAddCustomerData({
      ...addCustomerData,
      [e.target.name]:
        e.target.name === "siteCode" ? +e.target.value : e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleOnBlur = (e: any) => {
    const trimmedValue = e.target.value.trim();

    setAddCustomerData({
      ...addCustomerData,
      [e.target.name]: trimmedValue,
    });
  };

  const handleDateChange = (value: any) => {
    setAddCustomerData({ ...addCustomerData, dob: value });
    setErrors({ ...errors, dob: "" });
  };

  const handleReceiveMessage = () => {
    setRecievedMessage(!recievedMessage);
    setAddCustomerData({
      ...addCustomerData,
      receiveMessage: !recievedMessage ? "Y" : "N",
    });
  };

  const handleClose = () => {
    setShowDetail(false);
    setCustomerId("");
    setAddCustomerData({});
    setEditMode(false);
  };

  const handleSearch = () => {
    setSearch(!search);
    // setSort({ ...sort, skip: 0 });
  };

  const handleSearchTextChange = (e: any) => {
    setSearchKeyword(e.target.value);
    setSort({
      ...sort,
      [e.target.name]: e.target.value,
      skip: 0,
    });
    // setSort({ ...sort, [e.target.name]: e.target.value, skip: 0 });
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const customerModalButton = [
    {
      text: BUTTON_LABEL.CANCEL,
      action: handleClose,
      className: "btn btn theme-btn",
    },
  ];

  const handleBlur = (e: any) => {
    const trimmedValue = e.target.value.trim();

    setFilterValues({
      ...filterValues,
      [e.target.name]: trimmedValue,
    });
  };

  const handleSelectionSearch = (item: any, name: any) => {
    if (item?.value) {
      setFilterValues({
        ...filterValues,
        [name]: item.value,
      });
    } else {
      let updatedFilter: any = { ...filterValues };
      delete updatedFilter[name];
      setFilterValues(updatedFilter);
    }
    setFilterSelectionError("");
  };

  const handleSelect = (item: any, e: any, type: string) => {
    let selectedValue = convertToAppropriateType(item?.value, type);

    if (item?.value) {
      setFilterValues({
        ...filterValues,
        [e.target.name]: selectedValue,
      });
    } else {
      let updatedFilter: any = { ...filterValues };
      delete updatedFilter[e.name];
      setFilterValues(updatedFilter);
    }
    setFilterSelectionError("");
  };

  const handleDate = (dates: any, filterName: any) => {
    const [start, end] = dates;

    const fromDate = start ? new Date(start).toISOString() : null;
    let toDate = null;
    if (end) {
      var datestring = new Date(end).toISOString().split("T")[0];
      toDate = new Date(datestring + "T23:59:59.000+05:30").toISOString();
    }

    setFilterValues({
      ...filterValues,
      [filterName]: { from: fromDate, to: toDate },
    });
  };

  const filterContent = (
    handleSelectionSearch: any,
    handleSelect: any,
    handleDate: any
  ) => {
    return [
      {
        label: LABELS.CITY_TEXT,
        name: ACTION_LABEL.CITY,
        elementType: "selectSearch",
        action: handleSelectionSearch,
        type: "",
        operator: "is from",
      },
      {
        label: LABELS.STATE_TEXT,
        name: ACTION_LABEL.STATE,
        elementType: "selectSearch",
        action: handleSelectionSearch,
        type: "",
        operator: "is from",
      },
      {
        label: LABELS.GENDER_TEXT,
        name: ACTION_LABEL.GENDER,
        elementType: "select",
        action: handleSelect,
        type: "",
        operator: "is from",
      },
      {
        label: LABELS.CREATED_AT_TEXT,
        name: ACTION_LABEL.CREATED_AT,
        elementType: "createdAt",
        action: handleDate,
        type: "",
        operator: "is from",
      },
    ];
  };

  const columns = useMemo(
    () => [
      {
        header: LABELS.SALUTATION_TEXT,
        accessorKey: ACTION_LABEL.SALUTATION,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.FIRSTNAME_TEXT,
        accessorKey: ACTION_LABEL.FIRSTNAME,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.MIDDLE_NAME_TEXT,
        accessorKey: ACTION_LABEL.MIDDLENAME,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.LASTNAME_TEXT,
        accessorKey: ACTION_LABEL.LASTNAME,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.MOBILE_NO_TEXT,
        accessorKey: ACTION_LABEL.MOBILE,
        // accessorKey: ACTION_LABEL.MOBILE_NO,
        isShow: true,
        enableSorting: false,
      },
      {
        header: `${LABELS.ADDRESS_TEXT} 1`,
        accessorKey: `${ACTION_LABEL.ADDRESS}1`,
        isShow: true,
        enableSorting: false,
      },
      {
        header: `${LABELS.ADDRESS_TEXT} 2`,
        accessorKey: `${ACTION_LABEL.ADDRESS}2`,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.CITY_TEXT,
        accessorKey: ACTION_LABEL.CITY,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.STATE_TEXT,
        accessorKey: ACTION_LABEL.STATE,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.DISTRICT_TEXT,
        accessorKey: ACTION_LABEL.DISTRICT,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.PIN_TEXT,
        accessorKey: ACTION_LABEL.PIN,
        isShow: false,
        enableSorting: false,
      },
      // {
      //   header: LABELS.EMAIL_TEXT,
      //   accessorKey: ACTION_LABEL.EMAIL,
      //   isShow: false,
      //  enableSorting: false,
      // },
      {
        header: LABELS.REMARKS_TEXT,
        accessorKey: ACTION_LABEL.REMARKS,
        isShow: false,
        enableSorting: false,
      },
      // {
      //   header: LABELS.GST_STATE_TEXT,
      //   accessorKey: ACTION_LABEL.GST_STATE_NAME,
      //   isShow: false,
      //  enableSorting: false,
      // },
      // {
      //   header: LABELS.GST_IN_TEXT,
      //   accessorKey: ACTION_LABEL.GST_IN,
      //   isShow: false,
      //  enableSorting: false,
      // },
      {
        header: LABELS.ISD_CODE_TEXT,
        accessorKey: ACTION_LABEL.ISD_CODE,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.GENDER_TEXT,
        accessorKey: ACTION_LABEL.GENDER,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.DOB_TEXT,
        accessorKey: ACTION_LABEL.DOB,
        cell: ({ row }: any) =>
          standardDateConvert(row.original[ACTION_LABEL.DOB]),
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.RECIEVE_MESSAGE_TEXT,
        accessorKey: ACTION_LABEL.RECIEVE_MESSAGE,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.PREF_COMMUNICATION_MODE_TEXT,
        accessorKey: ACTION_LABEL.PREF_COMMUNICATION_MODE,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.SITE_CODE_TEXT,
        accessorKey: ACTION_LABEL.SITE_CODE,
        isShow: false,
        enableSorting: false,
      },
      {
        header: LABELS.CREATED_AT_TEXT,
        accessorKey: ACTION_LABEL.CREATED_AT,
        cell: ({ row }: any) =>
          dateConvert(row.original[ACTION_LABEL.CREATED_AT]),
        isShow: false,
        enableSorting: false,
      },
    ],
    [sort]
  );

  const setCheckBox = (flag: any) => {
    let updated = listCheck(JSON.parse(JSON.stringify(customerList)), flag);
    return updated;
  };

  const checkSelectedData = (data: any) => {
    return data.filter((ele: any) => {
      return ele.isSelected;
    });
  };

  const checked = (e: any, index: any) => {
    // setMultiDelete(true);
    let data = JSON.parse(JSON.stringify(customerList));

    if (e.target.checked) {
      data[index].isSelected = true;
    } else {
      data[index].isSelected = false;
    }
    setCustomerList(data);
    const visibleName = checkSelectedData(data);
    deleteShowModal(visibleName);
  };

  const removeMultiDelete = () => {
    let unSelected = setCheckBox(false);
    setCustomerList(unSelected);
    const visibleName = checkSelectedData(unSelected);
    deleteShowModal(visibleName);
  };

  const actionMultiDelete = () => {
    deleteShowModals();
    const visibleName = checkSelectedData(customerList);
    deleteShowModal(visibleName);
  };

  const allCheck = (e: any) => {
    // setMultiDelete(true);
    let data = [];
    data = setCheckBox(e.target.checked);
    const visibleName = checkSelectedData(data);
    deleteShowModal(visibleName);

    setCustomerList(data);
  };

  const handleRef = () => {
    iconInput.current.click();
  };

  const handleCsvImport = async (e: any) => {
    let formData = new FormData();
    formData.append("csv", e.target.files[0], e.target.files[0].name);
    const customerImportResponse = await customerImport(formData)
      .unwrap()
      .catch((err: any) => {
        toastError(err.data?.errors[0]?.msg);
      });
    if (customerImportResponse && customerImportResponse?.status) {
      customerImportFlow(customerImportResponse);
    }
  };

  const csvData = [
    {
      SALUTATION: "",
      FIRST_NAME: "Keyan",
      MIDDLE_NAME: "Shaktibhai",
      LAST_NAME: "Darji",
      ADDRESS1: "",
      ADDRESS2: "",
      CITY: "",
      STATE: "",
      DISTRICT: "",
      PIN: "",
      MOBILE: "9276665522",
      REMARKS: "",
      // GST_STATE_NAME: "",
      // GST_IN: "",
      ISD_CODE: "+91",
      GENDER: "M",
      DOB: "17/10/2024",
      RECIEVE_MESSAGE: "Y",
      PREF_COMMUNICATION_MODE: "S",
      SITE_CODE: 720,
    },
    {
      SALUTATION: "",
      FIRST_NAME: "Jaksh",
      MIDDLE_NAME: "Aksh",
      LAST_NAME: "Modi",
      ADDRESS1: "",
      ADDRESS2: "",
      CITY: "",
      STATE: "",
      DISTRICT: "",
      PIN: "",
      MOBILE: "9872287522",
      REMARKS: "",
      // GST_STATE_NAME: "",
      // GST_IN: "",
      ISD_CODE: "+91",
      GENDER: "M",
      DOB: "17/10/2024",
      RECIEVE_MESSAGE: "Y",
      PREF_COMMUNICATION_MODE: "S",
      SITE_CODE: 720,
    },
    {
      SALUTATION: "",
      FIRST_NAME: "Kantibhai",
      MIDDLE_NAME: "Dhirjibhai",
      LAST_NAME: "Mistry",
      ADDRESS1: "",
      ADDRESS2: "",
      CITY: "",
      STATE: "",
      DISTRICT: "",
      PIN: "",
      MOBILE: "9825378522",
      REMARKS: "",
      // GST_STATE_NAME: "",
      // GST_IN: "",
      ISD_CODE: "+91",
      GENDER: "M",
      DOB: "17/10/2024",
      RECIEVE_MESSAGE: "N",
      PREF_COMMUNICATION_MODE: "S",
      SITE_CODE: 201,
    },
    {
      SALUTATION: "",
      FIRST_NAME: "Jay",
      MIDDLE_NAME: "Kanubhai ",
      LAST_NAME: "Darji",
      ADDRESS1: "",
      ADDRESS2: "",
      CITY: "",
      STATE: "",
      DISTRICT: "",
      PIN: "",
      MOBILE: "9115375133",
      REMARKS: "",
      // GST_STATE_NAME: "",
      // GST_IN: "",
      ISD_CODE: "+91",
      GENDER: "M",
      DOB: "17/10/2024",
      RECIEVE_MESSAGE: "N",
      PREF_COMMUNICATION_MODE: "S",
      SITE_CODE: 4,
    },
  ];

  const handleView = (row: any) => {
    setCustomerId(row._id);
    setShowDetail(true);
  };

  const handleSave = async () => {
    const { formErrors, formValid } = customerValidation(addCustomerData);
    if (formValid) {
      if (editMode) {
        const customerUpdateResponse = await customerUpdate({
          id: customerId,
          data: addCustomerData,
        })
          .unwrap()
          .catch((err: any) => {
            toastError(
              err.data?.errors[0]?.msg || err.data?.errors[0]?.msg.messageText
            );
          });
        if (customerUpdateResponse && customerUpdateResponse?.status) {
          customerUpdateFlow(customerUpdateResponse);
        }
      } else {
        const customerAddResponse = await customerCreate(addCustomerData)
          .unwrap()
          .catch((err: any) => {
            toastError(
              err.data?.errors[0]?.msg || err.data?.errors[0]?.msg.messageText
            );
          });
        if (customerAddResponse && customerAddResponse?.status) {
          customerAddFlow(customerAddResponse);
        }
      }
    } else {
      setErrors(formErrors);
    }
  };

  const handleEdit = (row: any) => {
    setCustomerId(row._id);
    setShowCustomerModal(true);
  };
  const handleShowModal = (row: any) => (
    deleteShowModals(true), deleteShowModal([row])
  );

  const addCustomerModalButton = [
    {
      text: BUTTON_LABEL.SAVE,
      action: handleSave,
      className: "btn theme-btn",
      isLoading: editMode ? customerUpdateLoading : customerCreateLoading,
    },
    {
      text: BUTTON_LABEL.CANCEL,
      action: closeCustomerModal,
      className: "btn btn theme-btn",
    },
  ];

  const tableAction = (
    handleView: any,
    handleEdit: any,
    handleShowModal: any
  ) => {
    return [
      {
        elementType: "button",
        text: BUTTON_LABEL.VIEW,
        className: `${`icon ${icons.ICON_VIEW}`} mx-1 `,
        icon: `icon ${icons.ICON_VIEW}`,
        action: handleView,
        access: authProvider.show("customer", "view"),
      },
      {
        elementType: "button",
        text: BUTTON_LABEL.EDIT,
        className: `${`icon ${icons.ICON_EDIT}`} mx-1 `,
        // icon: "",
        action: handleEdit,
        access: authProvider.show("customer", "edit"),
      },
      // {
      //   elementType: "button",
      //   text: BUTTON_LABEL.DELETE,
      //   className: `${`icon ${icons.ICON_DELETE}`} mx-1 `,
      //   // icon: "",
      //   action: handleShowModal,
      // },
    ];
  };

  const action = tableAction(handleView, handleEdit, handleShowModal);

  // const deleteModal = (handleDelete: any, closeModal: any, isLoading: any) => {
  //   return [
  //     {
  //       text: BUTTON_LABEL.YES,
  //       action: handleDelete,
  //       className: "btn theme-btn theme-btn-sm w-auto",
  //       isLoading: isLoading,
  //     },
  //     {
  //       text: BUTTON_LABEL.NO,
  //       action: closeModal,
  //       className: "btn theme-btn theme-btn-sm btn-inverse w-auto",
  //     },
  //   ];
  // };

  // const handleDelete = async () => {
  //   const customerDeleteResponse = await customerDelete({ _id: deleteId })
  //     .unwrap()
  //     .catch((err: any) => {
  //       toastError(err.data?.errors[0]?.msg);
  //     });
  //   if (customerDeleteResponse && customerDeleteResponse?.status) {
  //     customerDeleteFlow(customerDeleteResponse);
  //   }
  // };

  // const closeModal = () => {
  //   deleteCloseModal();
  //   deleteShowModal([]);
  //   removeMultiDelete();
  // };

  // const deleteModalButton = deleteModal(
  //   handleDelete,
  //   closeModal,
  //   customerDeleteLoading
  // );

  return (
    <>
      <div className="full-height">
        <Navbar title={LABELS.CUSTOMER_MANAGEMENT_TEXT} />
        <main className="main-content">
          <div className="pt-3">
            <div className="container-fluid">
              <div className="row table-top-actions">
                <div className="col-12 col-md-12 d-flex justify-content-end">
                  <div className="d-flex align-items-center row w-100 mx-m-0">
                    <Search
                      placeholder={LABELS.SEARCH_TEXT}
                      name={ACTION_LABEL.SEARCH}
                      value={sort.search}
                      onChange={handleSearchTextChange}
                      onKeyDown={handleKeyDown}
                      onClick={handleSearch}
                    />

                    {authProvider.show("customer", "edit") && (
                      <>
                        <SimpleButton
                          className={
                            "me-2 btn theme-btn theme-btn-sm btn-inverse w-auto"
                          }
                          onClick={handleCustomerModal}
                          btnIcon={icons.ICON_ADD}
                          text={BUTTON_LABEL.ADD}
                        />

                        <SimpleButton
                          datatoggle="tooltip"
                          dataplacement="top"
                          title={BUTTON_LABEL.IMPORT}
                          className={
                            "me-2 btn theme-btn theme-btn-sm btn-inverse w-auto"
                          }
                          onClick={handleRef}
                          text={BUTTON_LABEL.IMPORT}
                        >
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={iconInput}
                            onChange={handleCsvImport}
                            accept=".csv"
                            onClick={(e: any) => {
                              e.target.value = null;
                            }}
                            hidden
                          />
                        </SimpleButton>
                        <CSVLink
                          data={csvData}
                          filename={"customer.csv"}
                          className="w-auto px-0"
                        >
                          <SimpleButton
                            datatoggle="tooltip"
                            dataplacement="top"
                            title={BUTTON_LABEL.SAMPLE_CSV}
                            className={
                              "me-2 btn theme-btn theme-btn-sm btn-inverse w-auto"
                            }
                            text={BUTTON_LABEL.SAMPLE_CSV}
                          />
                        </CSVLink>

                        {/* <SimpleButton
                      className={
                        "me-2 btn theme-btn theme-btn-sm btn-inverse w-auto"
                      }
                      // onClick={handleCsvExport}
                      text={BUTTON_LABEL.EXPORT}
                    /> */}
                      </>
                    )}

                    <SimpleButton
                      className={`me-2 btn theme-btn theme-btn-sm ${
                        Object.keys(sort.filter).length > 0 ? "" : "btn-inverse"
                      } filter-btn`}
                      btnIcon={icons.ICON_FILTER}
                      btnIconClass={"me-2 d-inline-block"}
                      onClick={handleCallFilter}
                    />
                  </div>
                </div>
              </div>
              <div className="card custom-card card-full mt-3">
                <div className="card-body p-0">
                  <Table
                    data={customerList}
                    columns={columns}
                    select={false}
                    action={action}
                    sort={sort}
                    setSort={setSort}
                    allCheck={allCheck}
                    allCheckedCheckbox={deleteId.length === customerList.length}
                    checked={checked}
                    coloumnDrop={true}
                    count={count}
                    isFetching={customerListFetching}
                    deleteId={deleteId}
                    removeMultiDelete={removeMultiDelete}
                    actionMultiDelete={actionMultiDelete}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* <CustomModal
        show={showModal}
        close={closeModal}
        message={`${MESSAGE.DELETE_MESSAGE} ${deletedName} Customer?`}
        size="md"
        modalTitle={""}
        modalButton={deleteModalButton}
        children={undefined}
        fullscreen={undefined}
        className={""}
        centerClass={""}
        modalTitleIcon={""}
        // modalTitleIcon={icons.ICON_DELETE_V2}
      /> */}

      <CustomModal
        show={showCustomerModal}
        close={closeCustomerModal}
        size={"lg"}
        message={""}
        modalTitle={
          editMode ? LABELS.EDIT_CUSTOMER_TEXT : LABELS.ADD_CUSTOMER_TEXT
        }
        modalButton={addCustomerModalButton}
        fullscreen={undefined}
        className={""}
        centerClass={""}
        modalTitleIcon={""}
      >
        <AddCustomer
          customerId={customerId}
          editMode={editMode}
          setEditMode={setEditMode}
          recievedMessage={recievedMessage}
          setRecievedMessage={setRecievedMessage}
          addCustomerData={addCustomerData}
          setAddCustomerData={setAddCustomerData}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleDateChange={handleDateChange}
          handleReceiveMessage={handleReceiveMessage}
          errors={errors}
        />
      </CustomModal>

      <CustomModal
        show={showDetail}
        close={handleClose}
        size={"lg"}
        message={""}
        modalTitle={LABELS.CUSTOMER_DETAILS_TEXT}
        modalButton={customerModalButton}
        fullscreen={undefined}
        className={"light-modal inventory-detail-modal"}
        centerClass={""}
        modalTitleIcon={""}
      >
        <CustomerDetail
          customerDetailData={customerDetailData}
          getCustomerLoading={getCustomerLoading}
        />
      </CustomModal>

      <Filter
        sort={filterValues}
        filterSelectionError={filterSelectionError}
        filterObject={filterContent(
          handleSelectionSearch,
          handleSelect,
          handleDate
        )}
        show={showFilter}
        onClose={closeFilter}
        handleReset={resetFilter}
        handleApply={handleApplyFilter}
        handleOnBlur={handleBlur}
      />
    </>
  );
};

export default Customer;
